<template>
  <!-- cookie acceptance screen when logging into the system, it must be accepted every time when logging in -->

  <div
    class="modal bd-example-modal-md"
    tabindex="-1"
    role="dialog"
    id="cookiesmodal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <p class="modal-title">Política de uso de Cookies</p>
        </div>
        <div class="modal-body">
          <cookies-policy></cookies-policy>
        </div>
        <div class="footer-style">
          <div class="agree-class">
            <label
              ><input
                id="agreeCookies"
                type="checkbox"
                value="agree"
                v-model="checkedCookie"
              />
              <span for="agreecookies" style="font-size: 15px"
                >Eu li e aceito a política de cookies</span
              ></label
            >
          </div>
          <div class="access-class">
            <button
              type="button"
              class="btn access"
              id="agreeCookiesButton"
              :disabled="!checkedCookie"
              v-on:click="cookiesModal()"
            >
              Aceito
            </button>
            <button
              type="button"
              class="btn access"
              id="dontAgreeCookiesButton"
              v-on:click="cookiesModalDontAccept()"
            >
              Não aceito
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import CookiesPolicy from "./accepts/CookiesPolicy";

export default {
  name: "CookiesConsent",
  components: {CookiesPolicy},
  data() {
    return {
      checkedCookie: false,
      userLogged: JSON.parse(localStorage.userLogged),
    };
  },

  methods: {
    cookiesModal: function () {
      axios
        .post(`${process.env.API_PBM}/accept/cookies`, { product: "pp" })
        .then((response) => {
          if (response.data.data) {
            $("#cookiesmodal").hide();
            if (this.$store.state.showAccepts.includes('privacy')) return $("#privacymodal").show();
          }
        });
    },

    cookiesModalDontAccept: function () {
      this.$store.dispatch("logout").then(() => {
        this.$router
          .push({ path: localStorage.getItem("group") })
          .catch(() => {});
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.access {
  color: #fff;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
  margin-right: 25px;
  margin-top: 5px;
}

.access-class {
  display: flex !important;
  justify-content: flex-end !important;
  width: 20% !important;
  height: 30% !important;
  margin-top: -15px !important;
}

.img-align {
  display: flex;
  justify-content: center;
}
.footer-style {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  margin-right: -20px;
}

.modal {
  color: rgb(100, 95, 95);
}

label {
  margin-left: 40px;
  margin-left: 35px;
}

.modal-content {
  padding: 5px;
}
.modal-title {
  font-size: 20px;
}

.modal-body {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  font-family: sans-serif !important;
  font-size: 14px;
}

@media only screen and (max-width: 960px) {
  /* styles for browsers larger than 960px; */

  label {
    margin-left: 25px;
    margin-bottom: 10px;
  }
  .modal-dialog {
    margin-top: 1%;
  }

  .modal-body {
    max-height: calc(60vh - 100px);
    overflow-y: auto;
    font-family: sans-serif !important;
    font-size: 14px;
  }
  .modal {
    padding: 15px;
  }

  .access {
    color: #fff;
    width: 35%;
    height: 80%;
    border-radius: 6px;
    cursor: pointer;
    padding: 5px;
    font-size: 17px;
    margin-right: 0px;
    margin-top: 10px;
    margin-bottom: 3px;
  }

  .access-class {
    display: flex !important;
    justify-content: space-around !important;
    width: 100% !important;
    height: 30% !important;
    margin-top: -15px !important;
    margin-left: -2% !important;
  }

  .footer-style {
    display: inline;
    margin-top: 27px;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/CookiesConsent.vue